import React from 'react';
import './Navbar.css';

function Navbar({ searchTerm, onSearchChange }) {
    return (
        <nav className="navbar">
            <div className="input-container">
                <input
                    className="search-input"
                    type="text"
                    placeholder="Pesquisar por número do processo..."
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </div>
            <a href="../ajuda/ac" className="help-link">Ajuda</a>
        </nav>
    );
}

export default Navbar;
